<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "UnitComponent",
};
</script>

<style scoped></style>
